import type * as React from "react";
import { BookingVehicleGridSkeleton } from "@/components/booking/BookingVehicleGridSkeleton";
import { Skeleton } from "@/components/ui/skeleton";

export const BookingStepOneSkeleton: React.FC = () => {
  return (
    <section className="mx-auto flex flex-col">
      <div className="flex-auto">
        <div className="flex justify-between border-b border-gray-200 bg-gray-50 px-8 py-4">
          <Skeleton className="h-9 w-3/4 max-w-lg" />
          <div className="flex items-end gap-2">
            <Skeleton className="h-8 w-24" />
            <Skeleton className="h-12 w-32 rounded-xl" />
          </div>
        </div>

        <div className="my-2 flex items-end gap-5 px-8">
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-4 w-52" />
          </div>
          <Skeleton className="h-9 w-9 rounded-md" />
          <Skeleton className="h-11 w-32 rounded-full" />
        </div>

        <div className="grid grid-cols-1 gap-4 px-8 py-6 md:grid-cols-2 xl:grid-cols-3">
          <BookingVehicleGridSkeleton />
        </div>
      </div>
    </section>
  );
};
